import React from 'react';
import './Features.css';

const Features = () => {
  const features = [
    {
      icon: '🌡️',
      title: 'Wireless Temperature Monitoring',
      description: 'Get instant updates on temperature readings with our advanced wireless sensors and indicators for precise climate control.',
      benefits: ['Real-time readings', '24/7 monitoring', 'Instant alerts']
    },
    {
      icon: '�',
      title: 'Water Level Control System',
      description: 'Monitor water levels in tanks, reservoirs, and sumps with wireless technology and automated alarm systems.',
      benefits: ['Wireless monitoring', 'Multi-level detection', '500m range'],
      image: '/images/dashboard.png'
    },
    {
      icon: '�',
      title: 'Advanced Wireless Technology',
      description: 'Secure 433-434 MHz wireless communication for both temperature and water level monitoring systems.',
      benefits: ['No wiring needed', 'Remote monitoring', 'Easy installation']
    },
    {
      icon: '📊',
      title: 'Real-time Data & Analytics',
      description: 'Live monitoring dashboards with comprehensive data analytics and trend visualization.',
      benefits: ['Live dashboards', 'Trend analysis', 'Historical data'],
      image: '/images/graph.png'
    },
    {
      icon: '⚡',
      title: 'Smart Alerts & Automation',
      description: 'Intelligent alarm systems for both temperature thresholds and water level management with automation.',
      benefits: ['Smart alarms', 'Auto controls', 'Emergency alerts']
    },
    {
      icon: '📝',
      title: 'Comprehensive Logging',
      description: 'Detailed logging and reporting for daily, monthly, and custom time periods with data export capabilities.',
      benefits: ['Daily logs', 'Monthly reports', 'Data export'],
      image: '/images/logs.png'
    }
  ];

  return (
    <section className="features" id="features">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose Our Smart Monitoring Solutions?</h2>
          <p>Discover the powerful features that make our wireless temperature and water level monitoring systems the best choice for comprehensive monitoring needs</p>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card" data-aos="fade-up" data-aos-delay={index * 100}>
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              {feature.image && (
                <div className="feature-image">
                  <img src={feature.image} alt={feature.title} />
                </div>
              )}
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <ul className="feature-benefits">
                  {feature.benefits.map((benefit, idx) => (
                    <li key={idx}>
                      <span className="check">✓</span>
                      {benefit}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
